import { useModalStore } from "@/hooks/Modal/hooks";
import { getNoticeInfoList } from "@/services/api/notice";
import React, { useEffect } from "react";
import NoticeListModal from "./NoticeListModal";

let isTip = false;

interface NoticeTipsProps {}

const NoticeTips: React.FC<NoticeTipsProps> = React.memo(function (props) {
  const modalStore = useModalStore();

  useEffect(() => {
    if (isTip) {
      return;
    }

    (async () => {
      const list = await getNoticeInfoList();

      if (list?.length) {
        modalStore.openModal(NoticeListModal, { data: list });
      }

      isTip = true;
    })();
  }, []);

  return null;
});

export default NoticeTips;
